<template>
  <section v-if="!isReady || isGetRequestPending" class="topics">
    <ab-loading />
  </section>

  <yn-with-title v-else :title="'Welcome!'" class="topics">
    <section class="topic-list-wrapper">
      <ab-introduction :collection="collection"> </ab-introduction>

      <ul v-if="collection.length" class="topic-list">
        <li v-for="item in collection" :key="item.id" class="topic-list-item">
          <label class="topic-list-item-stats">
            <span>{{ item.progress.done }} / {{ item.progress.total }}</span>
          </label>
          <h4>
            <router-link :to="`/labelling/${item.id}`"> {{ item.title }}</router-link>
          </h4>
          <div v-if="item.description">{{ item.description }}</div>
          <div v-else><i>no description</i></div>
          <div class="topic-list-item-action">
            <yn-button
              :disabled="leaveRequestPendingCollection && leaveRequestPendingCollection.includes(item.id)"
              @click="leave(item)"
            >
              Leave
            </yn-button>
          </div>
        </li>
      </ul>
    </section>
  </yn-with-title>
</template>

<script>
import { mapState } from 'vuex';

import Loading from './../common/Loading';
import Introduction from './Introduction';
import WithTitle from './../common/_WithTitle';
import Button from './../common/Button';

export default {
  components: {
    'ab-loading': Loading,
    'ab-introduction': Introduction,
    'yn-with-title': WithTitle,
    'yn-button': Button
  },
  meta: {
    title: 'Home'
  },
  data() {
    return {
      isReady: false
    };
  },
  computed: {
    ...mapState({
      currentIdentity: s => s.identity.email,
      collection: s => s.labelling.collection,
      isGetRequestPending: s => s.labelling.isGetCollectionPending,
      leaveRequestPendingCollection: s => s.labelling.leaveRequestPendingCollection
    })
  },
  async created() {
    await Promise.all([this.$store.dispatch('labelling/my')]);
    this.isReady = true;
  },
  methods: {
    async leave({ id }) {
      const confirmResult = await this.$confirm({
        title: 'Leave topic?',
        message: `Are you sure you want to leave this topic? Keep in mind that you will need an invite to join a topic which is not public.`,
        confirm: 'Leave'
      });

      if (!confirmResult) {
        return;
      }

      const lock = this.$lock();
      try {
        await this.$store.dispatch('labelling/leave', { id });
        this.$toast.success({
          title: 'Leave completed',
          message: 'You successfully left a topic.'
        });
      } catch (e) {
        this.$toast.error({
          title: 'Leave failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.topics {
  position: relative;
  padding-bottom: 1rem;

  .action-wrapper {
    padding: 1rem 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .topic-list-wrapper {
    display: grid;
    grid-gap: 1rem;
    grid-template-rows: max-content max-content;
  }

  .topic-list {
    list-style: none;
    margin: 0;
    .topic-list-item {
      width: 100%;
      position: relative;

      display: grid;
      grid-gap: 0 1rem;
      grid-template-columns: 75px minmax(0, 1fr) 75px;
      grid-template-rows: max-content max-content;
      color: #2d313d;
      transition: all 0.3s ease 0s;
      margin-top: 1.5rem;
      margin-bottom: 3rem;

      .topic-list-item-stats {
        grid-column: 1/2;
        grid-row: 1/3;
        align-self: center;
        justify-self: center;

        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: var(--theme-primary);

        top: 50%;

        font-weight: 700;
        font-size: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        padding: 0.25rem;
        text-align: center;
      }

      > h4 {
        grid-row: 1/2;
        grid-column: 2/3;
        font-size: 1.5rem;
        // margin: 0 0 1rem;
        padding: 0;
        line-height: 1.4;
        letter-spacing: 1px;
        color: #2d313d;
      }

      .topic-list-item-description {
        grid-row: 2/3;
        grid-column: 2/3;
      }

      .topic-list-item-action {
        grid-row: 1/3;
        grid-column: 3/4;
        align-self: center;
        justify-self: center;
        text-align: center;

        a {
          color: inherit !important;
        }
      }

      &:after {
        position: absolute;
        height: 1px;
        width: 100%;
        background-color: #dee2e6;
        bottom: -20px;
        text-align: center;
        content: '';
        // margin: 0 auto;
        right: 0;
        left: 0;
      }
    }
  }
}
</style>
